var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
export const BackgroundImage = forwardRef((_a, ref) => {
    var { src, style, imageStyle, imageClassName, children } = _a, props = __rest(_a, ["src", "style", "imageStyle", "imageClassName", "children"]);
    return (React.createElement("div", Object.assign({}, props, { ref: ref, style: Object.assign({}, style, { position: 'relative' }) }),
        React.createElement("img", { src: src, className: imageClassName, style: Object.assign({}, imageStyle, { position: 'absolute', width: '100%', height: '100%' }) }),
        children));
});
//# sourceMappingURL=background-image.js.map